/**
 * Mobile Menu
 * @dependencies jQuery
 * @dependencies Foundation
 */

import $ from 'jquery';
import { Drilldown } from 'fjs/foundation.drilldown';

Foundation.plugin(Drilldown, 'Drilldown');

const $triggerMenu = $('.js-menu-toggle');
const $drilldownEl = $('.js-mobile-menu');
const sizeChangeEvents = ['resize', 'orientationchange'];
let currentWidth = window.innerWidth;

if ($triggerMenu.length && $drilldownEl.length) {
  // We dont need fast load, so we can keep the slow `load` event lifecycle
  window.addEventListener('load', function () {
    // ### DrillDown Menu

    // Replace button with links to have drilldown submenu working
    $drilldownEl.find('button').each((i, el) => {
      const $this = $(el);
      $this.replaceWith(`<a>${$this.text()}</a>`);
    });

    // Settings
    const drilldownBackText = $drilldownEl.attr('data-back');
    const drilldownOptions = {
      backButton: `<li class="js-drilldown-back"><a class="drilldown-back" tabindex="0">${drilldownBackText}</a></li>`,
      // closeOnClick: true,
      parentLink: true,
      //scrollTop: true,
      autoHeight: true,
      animateHeight: true,
    };

    // Init
    const drilldownInstance = new Drilldown($drilldownEl, drilldownOptions);

    // ### Toggle Open/Close
    $triggerMenu.on('click', function (ev) {
      ev.preventDefault();
      $('body').toggleClass('nav-open');
    });
  });

  // To trigger drilldown refresh on resize / orientation change
  sizeChangeEvents.forEach((event) => {
    window.addEventListener(event, debounce(refreshDrilldown));
  });
}

// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {

      func.apply(this, args);
    }, timeout);
  };
}

// Destroy the last instance to rebuild with correct sizings
function refreshDrilldown() {
  const newWidth = window.innerWidth;
  if (currentWidth > 1024 && newWidth < 1024) {
    currentWidth = window.innerWidth;
    $($drilldownEl).removeClass('invisible');
    $($drilldownEl).foundation('_destroy');
    Foundation.reInit('drilldown');
  } else {
    currentWidth = window.innerWidth;
  }
}
